import {
    Button,
    Flex,
    Paper,
    PasswordInput,
    Title,
    LoadingOverlay,
} from '@mantine/core'
import { useForm } from '@mantine/form'
import { IRequestSaveForgetPassword } from '@apiinterface/IAuth'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import Auth from '@api/Auth'
const AdminForgetPassword = () => {
    const [searchParams] = useSearchParams()
    const navigate = useNavigate()

    const form = useForm<IRequestSaveForgetPassword>({
        initialValues: {
            password: '',
            confirmpassword: '',
        },
    })

    const { onSubmit, isLoading } = Auth.useSaveForgetPassword({
        form,
        withToken: `Bearer ${searchParams.getAll('token')[0]}`,
        aftersuccess: () => {
            navigate('/login')
        },
    })

    return (
        <Flex
            justify='center'
            align='center'
            w='100%'
            mih='100vh'
            bg='primary.0'
        >
            <Paper
                maw={350}
                shadow='xl'
                w='100%'
                mx='auto'
                p='xl'
                m='xl'
                bg='white'
                radius='lg'
                pos='relative'
                style={{ overflow: 'hidden' }}
            >
                <LoadingOverlay visible={isLoading} />
                <form onSubmit={onSubmit}>
                    <Title order={3} mb='lg' ta='center'>
                        ตั้งรหัสผ่านใหม่
                    </Title>
                    <PasswordInput
                        mt='md'
                        label='รหัสผ่าน'
                        placeholder='รหัสผ่าน'
                        {...form.getInputProps('password')}
                    />
                    <PasswordInput
                        mt='md'
                        label='ยืนยันรหัสผ่าน'
                        placeholder='ยืนยันรหัสผ่าน'
                        {...form.getInputProps('confirmpassword')}
                    />

                    <Button type='submit' fullWidth mt='xl'>
                        เปลี่ยนรหัสผ่าน
                    </Button>
                    <Button
                        type='button'
                        component={Link}
                        to='/login'
                        fullWidth
                        variant='light'
                        mt='lg'
                    >
                        กลับไปยังหน้าเข้าสู่ระบบ
                    </Button>
                </form>
            </Paper>
        </Flex>
    )
}

export default AdminForgetPassword
